import React, {useState} from "react";
import { Button } from "@material-ui/core";
import { HelpOutlineOutlined } from "@material-ui/icons";
import { billingV2Styles } from "./BillingV2Style";
import HowItWorksModal from "../Common/HowItWorksModal";

const HeaderSection = () => {
    const classes = billingV2Styles();
    const [openHowItsWorksModal, setOpenHowItsWorksModal] = useState(false);


  return (
    <div className={classes.headerWrapper}>
      <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
        <img
          src={`${process.env.REACT_APP_CDN_LINK}assets/images/releases/billing/1.0.0/card_icon.png`}
          alt="logo"
          height={60}
          width={60}
        />

        <h4 style={{ margin: 0, color: "#001d35" }}>Billing Dashboard</h4>
      </div>

      <Button
        size="small"
        variant="text"
        style={{ backgroundColor: "#8d8d8d52", padding: "7px 16px" }}
        onClick={() => setOpenHowItsWorksModal(true)}
        startIcon={<HelpOutlineOutlined />}
      >
        <span>How IT WORKS</span>
      </Button>

        {openHowItsWorksModal && (
            <HowItWorksModal
                open={openHowItsWorksModal}
                onClose={() => setOpenHowItsWorksModal(false)}
                videoSrc=''
            />
        )}
    </div>
  );
};

export default HeaderSection;
